import { defineStore } from "pinia";
export const useUserStore = defineStore("userdata", {
  state: () => ({
    user: {}, //MFA
    login: {}, //Login backend
    profile: {}, //Perfil Maximo
    loading: false,
    error: null,
    locale: "es-ES",
  }),
  actions: {
    setUser(value) {
      this.user = value;
      localStorage.setItem("user", JSON.stringify(value));
    },
    setLoading(value) {
      this.loading = value;
    },
    setError(value) {
      this.error = value;
    },
    setLogin(value) {
      // HACK: Cambiar rol
      /* value.Modulos.forEach((modulo) => {
        if (modulo.CodigoModulo === MSCmodule) {
          modulo.CodigoRol = roles["technician"]; // Asignamos el nuevo CodigoRol
        }
      }); */

      this.login = value;
      localStorage.setItem("login", JSON.stringify(value));
    },
    setProfile(value) {
      // HACK: Cambiar subcontrata
      // value.SUBCONTRACTOR = "90";
      // value.DEFAULTPERSONGROUP = "1021";
      this.locale = value.LOCALE.replace("_", "-");
      this.profile = value;
      localStorage.setItem("profile", JSON.stringify(value));
    },
    cleanError() {
      this.error = null;
    },
    cleanUser() {
      this.user = {};
      localStorage.removeItem("user");
    },
    cleanLogin() {
      this.login = {};
      localStorage.removeItem("login");
    },
    cleanProfile() {
      this.profile = {};
      localStorage.removeItem("profile");
    },
    resetLogin() {
      this.cleanError();
      this.cleanUser();
      this.cleanLogin();
      this.cleanProfile();
    },
    async logout(accountId) {
      // Limpiar estado local de filtros de Scheduling ANTES de iniciar logout redirect.
      // Motivo: `logoutRedirect` puede navegar y cortar la ejecución, dejando
      // claves persistidas (p. ej. globalScheduling:filters) “atascadas”.
      try {
        localStorage.removeItem("globalScheduling:filters");
      } catch (_) {
        // noop
      }

      console.log("Cerrar sesión usuario con accountId:", accountId);

      const nuxtApp = useNuxtApp();

      try {
        // Intenta cerrar sesión con MSAL
        await nuxtApp.$msal().signOut(accountId);

      } catch (error) {
        
        // Maneja el error, pero permite que el flujo continúe
        console.error("Error during logout:", error);
  
      }

      // Limpiar el estado del usuario incluso si ocurre un error
      this.resetLogin();
      localStorage.removeItem("loggedIn");
      localStorage.clear();
      console.log("Desconectando usuario");

      // Redirige al usuario a la página de inicio de sesión o a la página principal
      // const loginPath = nuxtApp.$localePath("/login");
      // nuxtApp.$router.push(loginPath);
      
      // Redirige al usuario a la página de inicio de sesión en la raíz
      window.location.href = "/login";

    }
  },
  getters: {
    getProfilePersonid: (state) => state.profile?.PERSONID,
    getUser: (state) => state.user,
    getLogin: (state) => state.login,
    getProfile: (state) => state.profile,
    getUserLocale: (state) =>
      state.profile?.LOCALE || state.login?.Lng || getBrowserLocale(),
    getError: (state) => state.error,
    getLoading: (state) => state.loading,
    getUserRole: (state) => {
      return state?.login?.Modulos?.find(
        (module) => module.CodigoModulo === MSCmodule
      )?.CodigoRol;
    },
    isRegularSubcontractor: (state) => {
      return state.getUserRole === roles["regularSubcontractor"];
    },
    isTechnician: (state) => {
      return state.getUserRole === roles["technician"];
    },
    isSquadChief: (state) => {
      return state.getUserRole === roles["squadChief"];
    },
    getSubcontractor: (state) => {
      return state?.profile?.SUBCONTRACTOR;
    },
  },
});
